import React, { useState } from "react";
import { Typography, Form, Input, Button, Divider, notification } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import GoogleIconSvg from "../../../assets/devicon_google.svg";
// import FacebookIconSvg from "../../../assets/logos_facebook.svg";
import { useRegisterEnumeratorContext } from "context/RegisterEnumeratorContext";
import { useSignUpWithGoogle } from "api/register/useSignUpWithGoogle";
// import { useFacebookAuth } from "api/register/useSignUpWithFacebook";
import { useNavigate } from "react-router-dom";


const { Title, Text } = Typography;

type ConfigureEmailProps = {
  Email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setCompanyName: React.Dispatch<React.SetStateAction<string>>;
  roleType: string | null;
};

const ConfigureEmail: React.FC<ConfigureEmailProps> = ({ Email,setEmail, setCompanyName, roleType }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setRegistrationSteps, registrationSteps } = useRegisterEnumeratorContext();
  const [isLoading, setIsLoading] = useState(false);

  const { mutate: signUpWithGoogle } = useSignUpWithGoogle();
  // const { mutate: signUpWithFacebook } = useFacebookAuth(true); // true indicates signup

  const handleSubmit = async () => {
    try {
      const parameters = await form.validateFields();
      setIsLoading(true);

      setEmail(parameters.email);
      setCompanyName(parameters.companyName);
      setRegistrationSteps({
        ...registrationSteps,
        isEmail: false,
        isPassword: true,
      });
    } catch (error) {
      notification.error({
        message: "Registration Failed",
        description: error instanceof Error ? error.message : "An error occurred during registration.",
      });
      setIsLoading(false);
    }
  };

  const loginWithGoogle = async () => {
    signUpWithGoogle(navigate, {
      onSuccess: (data) => {
        if (data) {
          navigate("/enumerator/home");
        }
      },
    });
  };

  // const loginWithFacebook = async () => {
  //   signUpWithFacebook(navigate);
  // };
  return (
    <>
      <Title level={2}>Create an account or sign in</Title>
      <Text type="secondary">
      Sign up with your recruiter account and complete your profile. Verify your organization’s credentials to build trust with top talent.
      </Text>
      <div className="mt-6">
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            name="email"
            label="Email"
            initialValue={Email}
            rules={[
              {
                required: true,
                message: "Email is required",
              },
            ]}
          >
            <Input placeholder="Enter email address" />
          </Form.Item>

          <Button
            htmlType="submit"
            type="primary"
            loading={isLoading}
            className="h-12 px-8 border-2 border-border text-base  flex justify-center items-center gap-2 bg-primary text-white border-none w-full mt-12"
          >
            Continue
            <ArrowRightOutlined />
          </Button>
        </Form>
      </div>

      <div className="mt-8 flex justify-center">
        <Text className="text-base ">
          <p></p>By continuing, you agree to the updated <p className="font-bold">Terms of Service <span className="font-normal">and</span> Privacy Policy</p>
        </Text>
      </div>

      <Divider>Or</Divider>

      <div className="flex flex-col gap-4">
        <Button
          className="h-12 px-8 border-1 border-grey text-base font-bold flex justify-center items-center gap-2 w-full"
          onClick={loginWithGoogle}
        >
          <img alt="Google Icon" src={GoogleIconSvg} />
          Continue with Google
        </Button>

        {/* <Button
          className="h-12 px-8 border border-1 border-grey text-base font-bold flex justify-center items-center gap-2 w-full"
          onClick={loginWithFacebook}
        >
          <img alt="Facebook Icon" src={FacebookIconSvg} />
          Continue with Facebook
        </Button> */}
      </div>
      <div className="mt-8">
        <Button
          type="default"
          onClick={() => navigate(-1)}
          className="h-12 px-8 border-2 border-border text-base flex justify-center items-center gap-2 w-full"
        >
          Back
        </Button>
      </div>
    </>
  );
};

export default ConfigureEmail;